import React, { useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../../common/types';
import { v4 as uuidv4 } from 'uuid';
import {
    Grid,
    Button,
    Select, MenuItem,
    FormHelperText, FormControl,
    GridList, GridListTile, GridListTileBar,
    withWidth, isWidthUp, LinearProgress,
} from '@material-ui/core';
import { useStyles } from "../styles";
import * as Icons from "../iconComponents";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import AttachmentImageSvg from "../../../assets/icons/pcr/attachment_image.svg";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import IndexedDb from '../IndexedDb';
import { url } from 'inspector';
import api from "../../../store/api";
import { useSelector } from "react-redux";
import { pcrstate } from "../../../store/modules/PcrSlice";
import { useDispatch } from 'react-redux';
import PcrSlice, { setpcrstate } from '../../../store/modules/PcrSlice';
interface PcrWidgetProps extends IAppPropsWithRoute {

};
interface Files {
    Key:string;
    img:any;
    Title:string;
}
const SubFormWidget: React.FC<PcrWidgetProps> = (props: any) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const [file, setFile] = useState(" ");
    const [fileName, setFileName] = useState("");
    const[Item,setItem]=useState(0);
    const[Key,setKey]=useState(0);
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useFormContext();
    const pcrType = watch("pcr_type");
    const {
        fields: AttachmentsFields,
        append: AttachmentsAppend,
        remove: AttachmentsRemove
    } = useFieldArray({ control, name: "attachments" });
    const[Indexdb,setIndexdb]=useState("");
    const formData = new FormData();
    const [visibileProgress, setvisibileProgress] = React.useState(false);
    const [Attachement,setAttachement] = React.useState<Files[]>([]);
    const [fileErrorMsg, setFileErrorMsg] = React.useState("");
    const pcr = useSelector(pcrstate)
    const Alt = getValues("altered_calling_criteria");
    const Tre = getValues("treatment_limiting_order");
    const Cardiac = getValues("cardiac_monitored");
    React.useEffect(() => {
        let db:any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        getindexdbvalues();
    }, [])
    React.useEffect(() => {      
        if(pcr.ShowImg)
        {
            getindexdbvalues();
        }
    }, [pcr.ShowImg])
    const getindexdbvalues = async (): Promise<void> => {
        let db:any = null;
        let observationdata = null ;
        db = localStorage.getItem("PatientDB");
        if(db!=null && db !="")
        {
        const indexedDb = new IndexedDb(db);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let val = await indexedDb.getAllValue('Attachement');
        let img:any=[];
        for(let i=0;i<val.length;i++)
        {
            
            if(val[i].Key.includes("AlteredCallingCriteriaImg"))
            {
                let res = val[i].value.img;               
                setKey(res.Keyvalue);
                img.push({
                    Key :val[i].Key,
                    img:res,
                    Title:val[i].value.title,
                })              
                //await AttachmentsAppend(res);            
            }
        }  
        let bg = await indexedDb.getAllValue('background');
        for(let i=0;i<bg.length;i++)
        {                      
            if(bg[i].Key.includes("AlteredcallingcriteriaImage"))
            {
                let res = bg[i].value.img;
                //setKey(res.Keyvalue);
                img.push({
                    Key :bg[i].Key,
                    img:res,
                    Title:bg[i].value.Title,
                })                              
            }
        }  
        let Ass = await indexedDb.getAllValue('AssessmentPlan');
        for(let i=0;i<Ass.length;i++)
        {                      
            if(Ass[i].Key.includes("TreatmentLimitingOrderPhoto"))
            {
                let res = Ass[i].value.img;
                //setKey(res.Keyvalue);
                img.push({
                    Key :Ass[i].Key,
                    img:res,
                    Title:Ass[i].value.Title,
                })                              
            }
        }  
        let Obs = await indexedDb.getAllValue('Attachement');
        for(let i=0;i<Obs.length;i++)
        {                      
            if(Obs[i].Key.includes("AddPhotoOfCardiacTrace"))
            {
                let res = Obs[i].value.img;
                //setKey(res.Keyvalue);
                img.push({
                    Key :Obs[i].Key,
                    img:res,
                    Title:Obs[i].value.Title,
                })                              
            }         
        }  
        let Tar = await indexedDb.getAllValue('Attachement');
        for(let i=0;i<Tar.length;i++)
        {                      
            if(Tar[i].Key.includes("TraumachartPhoto"))
            {
                let res = Tar[i].value.img;
                //setKey(res.Keyvalue);
                img.push({
                    Key :Tar[i].Key,
                    img:res,
                    Title:Tar[i].value.Title,
                })                              
            }         
        }  
        setAttachement(img);      
        }      
    }
    const getGridListCols = (): number => {
        if(isWidthUp('xl', props.width))
        {
            return 5.5;
        }
        if(isWidthUp('lg', props.width))
        {
            return 4.5;
        }
        if(isWidthUp('md', props.width))
        {
            return 3.5;
        }
        if(isWidthUp('sm', props.width))
        {
            return 2.5;
        }
        return 1.5;
      }
      const handleindexdbdelete = async (Key:any,Title:any): Promise<void> => {     
        if(Indexdb!=null || Indexdb !="")
        {
        if(Title === "Altered Calling Criteria")
        {
            dispatch(setpcrstate({name:"DeleteAlteredcallingcriteriaImage",value:false}))
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);      
            await indexedDb.deleteValue('background', Key);  
            dispatch(setpcrstate({name:"DeleteAlteredcallingcriteriaImage",value:true}))
        }
        if(Title === "Treatment Limiting Order / ACD / NFR")
        {
            dispatch(setpcrstate({name:"DeleteTreatmentLimitingOrderPhoto",value:false}))
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);      
            await indexedDb.deleteValue('AssessmentPlan', Key);  
            dispatch(setpcrstate({name:"DeleteTreatmentLimitingOrderPhoto",value:true}))
        }
        if(Title === "Trauma Chart")
        {
            dispatch(setpcrstate({name:"DeleteTraumachartPhoto",value:false}))
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);      
            await indexedDb.deleteValue('Attachement', Key); 
            dispatch(setpcrstate({name:"DeleteTraumachartPhoto",value:true}))
        }
        if(Title === "Cardiac Trace")
        {
            dispatch(setpcrstate({name:"DeleteAddPhotoOfCardiacTrace",value:false}))
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);      
            await indexedDb.deleteValue('Attachement', Key);  
            dispatch(setpcrstate({name:"DeleteAddPhotoOfCardiacTrace",value:true}))
        }
        else{
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);      
            await indexedDb.deleteValue('Attachement', Key);  
        }     
        }  
        getindexdbvalues();   
    }
    const saveFile = async (event:any) => {           
        //let val = value[0];    
        var Attachementtype = getValues("attcahment_title")
        if(Attachementtype === "AlteredcallingcriteriaImage")
        {
            dispatch(setpcrstate({name:"ShowImg",value:false}))
            const file = event.target.files[0];
            const reader = new FileReader();
            let uint8 = new Uint8Array(await file.arrayBuffer());
            //const blob = new Blob([uint8], { type: "image/jpeg" });
            //const imageUrl = URL.createObjectURL(blob);
            const imageUrl =null;
            const indexedDb = new IndexedDb(Indexdb);
            const base64 = await indexedDb.convertToBase64(file);
            //const buffer = Buffer.from(base64.toString().substring(base64.indexOf(',') + 1));

            let updatedFileName = generateRandomGuid() +"_" + file.name;
            const updatedFile = new File([file], updatedFileName, {
                type: file.type,
                });

                if(Indexdb!=null || Indexdb !="")
                {       
                await indexedDb.createObjectStore(indexedDb.patientcarerecord);
                await indexedDb.deleteValue('background', "AlteredcallingcriteriaImage");
                await indexedDb.putValue('background', { column:uint8,type:file.type,file:updatedFileName,imageurl:imageUrl,imagesize:uint8.byteLength,Base64:base64,Patid:0,img:updatedFile,Title:"Altered Calling Criteria" },"AlteredcallingcriteriaImage");          
                    }        
            formData.append('file', updatedFile);
            dispatch(setpcrstate({name:"ShowImg",value:true}))
        }
        if(Attachementtype === "TreatmentLimitingOrderPhoto")
        {
            dispatch(setpcrstate({name:"ShowImg",value:false}))
            const file = event.target.files[0];
            const reader = new FileReader();
            let uint8 = new Uint8Array(await file.arrayBuffer());
            const blob = new Blob([uint8], { type: "image/jpeg" });
            const imageUrl = URL.createObjectURL(blob);
            //const buffer = Buffer.from(base64.toString().substring(base64.indexOf(',') + 1));
            const indexedDb = new IndexedDb(Indexdb);
            const base64 = await indexedDb.convertToBase64(file);
            //const buffer = Buffer.from(base64.toString().substring(base64.indexOf(',') + 1));
            let updatedFileName = generateRandomGuid() +"_" + file.name;
                const updatedFile = new File([file], updatedFileName, {
                    type: file.type,
                  });
        
            if(Indexdb!=null || Indexdb !="")
            {       
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.deleteValue('AssessmentPlan', "TreatmentLimitingOrderPhoto");
            await indexedDb.putValue('AssessmentPlan', { column:uint8,type:file.type,file:updatedFileName,imageurl:imageUrl,imagesize:uint8.byteLength,Base64:base64,Patid:0,img:updatedFile,Title:"Treatment Limiting Order / ACD / NFR"  },"TreatmentLimitingOrderPhoto");
            }
            
            formData.append('file', updatedFile);
           dispatch(setpcrstate({name:"ShowImg",value:true}))
        }
        if(Attachementtype === "TraumachartPhoto")
        {
           dispatch(setpcrstate({name:"ShowImg",value:false}))
            const reader = new FileReader();
            const file = event.target.files[0];
            let uint8 = new Uint8Array(await file.arrayBuffer());
            const blob = new Blob([uint8], { type: "image/jpeg" });
            const imageUrl = URL.createObjectURL(blob);
            const indexedDb = new IndexedDb(Indexdb);
            const base64 = await indexedDb.convertToBase64(file);
            //const buffer = Buffer.from(base64.toString().substring(base64.indexOf(',') + 1));
        
            let updatedFileName = generateRandomGuid() +"_" + file.name;
            const updatedFile = new File([file], updatedFileName, {
                type: file.type,
              });
            if(Indexdb!=null || Indexdb !="")
            {       
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('Attachement');
            var res =null;
            let rows = 0;
            let itemval:any=[];
            for(let i=0;i<val.length;i++)
            {                             
                if (val[i].Key.includes("TraumachartPhoto")) {
                    res = val[i].Key;   
                    var keyval = res.split("TraumachartPhoto")[1]; 
                    itemval.push(Number(keyval));
                }   
            }  
            if(itemval.length >0)
            {
                rows = (Math.max(...itemval) + 1);
            }                     
            //await indexedDb.deleteValue('Attachement', Key);
            await indexedDb.putValue('Attachement', { column:uint8,type:file.type,file:updatedFileName,imageurl:imageUrl,imagesize:uint8.byteLength,Base64:base64,Patid:0,img:updatedFile,Title:"Trauma Chart"},"TraumachartPhoto"+rows);
            }
            formData.append('file', updatedFile);
           dispatch(setpcrstate({name:"ShowImg",value:true}));
        }
        if(Attachementtype ==="AddPhotoOfCardiacTrace")
        {
            dispatch(setpcrstate({name:"ShowImg",value:false}))
            const reader = new FileReader();
            const file = event.target.files[0];
            let uint8 = new Uint8Array(await file.arrayBuffer());
            const blob = new Blob([uint8], { type: "image/jpeg" });
            const imageUrl = URL.createObjectURL(blob);
            const indexedDb = new IndexedDb(Indexdb);
            const base64 = await indexedDb.convertToBase64(file);
            //const buffer = Buffer.from(base64.toString().substring(base64.indexOf(',') + 1));

            let updatedFileName = generateRandomGuid() +"_" + file.name;
            const updatedFile = new File([file], updatedFileName, {
                type: file.type,
                });
            if(Indexdb!=null || Indexdb !="")
            {       
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('Attachement');
            var res =null;
            let rows = 0;
            let itemval:any=[];
            for(let i=0;i<val.length;i++)
            {                             
                if (val[i].Key.includes("AddPhotoOfCardiacTrace")) {
                    res = val[i].Key;   
                    var keyval = res.split("AddPhotoOfCardiacTrace")[1]; 
                    itemval.push(Number(keyval));
                }   
            } 
            if(itemval.length >0)
            {
                rows = (Math.max(...itemval) + 1);
            }                   
            //await indexedDb.deleteValue('Attachement', Key);
            await indexedDb.putValue('Attachement', { column:uint8,type:file.type,file:updatedFileName,imageurl:imageUrl,imagesize:uint8.byteLength,Base64:base64,Patid:0,img:updatedFile,Title:"Cardiac Trace"},"AddPhotoOfCardiacTrace"+rows);
            }
            formData.append('file', updatedFile);
           dispatch(setpcrstate({name:"ShowImg",value:true}));
        }
        if(Attachementtype === "Attachments")
        {
        let val = event.target.files[0];  
        let Keys:number=0;
        
        if(AttachmentsFields.length >0)
        {
            Keys = Key+1; 
        }
        else
        {
            setItem(prevCount => prevCount + 1);
            Keys = Keys + Item; 
        }
        let updatedFileName = generateRandomGuid() +"_" + val.name;
        const updatedFile = new File([val], updatedFileName, {
            type: val.type,
          });

        if(Indexdb!=null || Indexdb !="")
        {
            const indexedDb = new IndexedDb(Indexdb);
            const base64 = await indexedDb.convertToBase64(val);
            
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.putValue('Attachement', { img:updatedFile,Base64:base64,title:"General Attachment",Key:'AlteredCallingCriteriaImg'+Keys,Keyvalue:Keys,Patid:0 },'AlteredCallingCriteriaImg'+Keys);
        }
       
        formData.append('file', updatedFile);        
        await AttachmentsRemove();
        }
        await saveFiletoBlobStorage()
        await getindexdbvalues();
      };

      const generateRandomGuid  = () => {
        const newGuid = uuidv4();
        return newGuid;
      };


      const saveFiletoBlobStorage = async (): Promise<void> => {
        try {
            setvisibileProgress(true)
            const res = await api.pushFileToBlobStorage("",formData);
            if(res?.error)
            {
                alert("Error Occurs while Uploading")
            }
            setvisibileProgress(false)
            formData.delete('file');
        } catch(error) {
            setvisibileProgress(false)
        }
    };
    
    const validateImage = async(value: any) => {
        let db = localStorage.getItem("PatientDB");
        if(db != null && db != "")
        {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let Attachement = await indexedDb.getAllValue('Attachement');
            let acceptedFormats = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/heic"];
            for(let i=0;i<Attachement.length;i++)
            {
                if(!acceptedFormats.includes(Attachement[i].value.img.type))
                {
                    return 'Only JPEG and PNG images are allowed for Attachments.';
                }
            }
        }     
        return true;
    };
    const handleFileChange = (event: any) => {   
        // Access the selected file using the event object
        let acceptedFormats = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/heic"];
        const file = event.target.files[0];
        if(file)
        {
            setFileErrorMsg("");
            if(file.type && acceptedFormats.includes(file.type))
            {
                // Perform your desired actions with the file
                saveFile(event);
            }
            else
            {
                setFileErrorMsg("Invalid file format!");
                setTimeout(() => {
                    setFileErrorMsg("");
                }, 8000);
            }
            // Reset the file input value to an empty string
            event.target.value = "";
        }
    };
    
    return (
        <div>
            <div className={classes.pcrAddTabHeading}>
                <div>
                    Attachments
                </div>
            </div>
            <Grid container className={classes.formContainer} spacing={3}>
                <Grid item xs={12} sm={12}>
                    <div className={classes.attachmentsFormList}>
                    <GridList spacing={15} className={"gridList"} cols={getGridListCols()}>
                        {Attachement.map((item, index) => (
                        <GridListTile key={index} rows={1} style={{ height: "250px" }}>
                            <GridListTileBar
                                titlePosition="top"
                                actionPosition="right"
                                //title={item.img.name.split("_")[1].split(".")[0]}
                                title={item.Title}
                                classes={{
                                    root: "titleBar",
                                    title: "title",     
                                    titleWrap: "wrap",
                                }}
                                actionIcon={
                                    <div
                                        className={"removeBtn"} 
                                        onClick={event => {
                                            //AttachmentsRemove(index)
                                            handleindexdbdelete(item.Key,item.Title)                                                                       
                                        }}
                                    >
                                        <Icons.CloseLightIcon />
                                    </div>
                                }
                            />
                            {(item.img != null) && (
                            <img src={URL.createObjectURL(item.img)} alt="attachment" className={"attachment"} />
                            )}
                        </GridListTile>
                        ))}
                    </GridList>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={5}>
                            <Controller
                                control={control}
                                name={"attcahment_title"}
                                defaultValue={"Attachments"}
                                render={({ onChange, onBlur, value, name }) => (
                                    <>
                                        <FormControl fullWidth error={errors.attcahment_title}>
                                            <Select
                                                name={name}
                                                value={value}
                                                onChange={(e: any) => { onChange(e) }}
                                                className={`${classes.selectField} bold`}
                                                IconComponent={KeyboardArrowDownIcon}                                          
                                               // displayEmpty
                                                fullWidth={true}
                                                variant="outlined"
                                            >
                                                {/* <MenuItem key="None" value="">Choose</MenuItem> */}
                                                <MenuItem selected  key={1} value={"Attachments"}>{"General Attachment"}</MenuItem>
                                                {Alt === 1 ? 
                                                <MenuItem key={2} value={"AlteredcallingcriteriaImage"}>{"Altered Calling Criteria"}</MenuItem>:null}
                                                {Tre === 1? 
                                                <MenuItem key={3} value={"TreatmentLimitingOrderPhoto"}>{"Treatment Limiting Order / ACD / NFR"}</MenuItem>:null}
                                                <MenuItem key={4} value={"TraumachartPhoto"}>{"Trauma Chart"}</MenuItem>
                                                {Cardiac === 1? 
                                                <MenuItem key={5} value={"AddPhotoOfCardiacTrace"}>{"Cardiac Trace"}</MenuItem>:null}
                                            </Select>
                                            <FormHelperText>{errors.attcahment_title ? errors.attcahment_title.message : ""}</FormHelperText>
                                            {visibileProgress && (
                                            <div style={{ width: '100%' }}>
                                                <LinearProgress />
                                            </div>
                                            )}
                                        </FormControl>
                                    </>
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                        <Controller
                                control={control}
                                name="Attachements"
                                defaultValue=""
                                render={({ onChange, onBlur, value, name }) => (
                                    <>
                                        <Button
                                            variant="contained"
                                            className={classes.yellowBtn} 
                                            component="label"
                                            startIcon={<Icons.PhotoIcon />}
                                            //onClick={() => AttachmentsAppend({ title: " ",img:null})}
                                        >
                                            Attach Photo
                                            <input
                                                {...value}
                                                name={name}                                        
                                                type="file"
                                                // onChange={(e) => onChange(e.target.files,handleindexdbImagesave('AlteredCallingCriteriaImg',e))}
                                                // onChange={(e) => {                                          
                                                //     saveFile(e.target.files)
                                                //  } }  
                                                onChange={handleFileChange}
                                                accept="image/*"
                                                //style={{ display: "none" }}
                                                hidden
                                        />
                                        </Button>
                                        <FormHelperText error={errors.Attachements}>
                                            {errors.Attachements ? errors.Attachements.message : ""}
                                        </FormHelperText>
                                        {(!!fileErrorMsg) && <FormHelperText error={true}>{fileErrorMsg}</FormHelperText>}
                                    </>
                                )}
                                rules={{
                                    //required: "This field is required",
                                    validate: validateImage,
                                    // validate: (value) => {
                                    //     if(value)
                                    //     {
                                    //         let acceptedFormats = ["image/jpeg", "image/png", "image/png", "image/gif"];
                                    //         if(!acceptedFormats.includes(value[0]?.type))
                                    //         {
                                    //             return "Only PNG, JPEG, PNG, GIF is allowed";
                                    //         }
                                    //         // else if(files[0]?.size > 2 * 1000 * 1000)
                                    //         // {
                                    //         //     return "Max 2 MB allowed";
                                    //         // }
                                    //     }
                                    // },
                                }}
                            />
                            {/* <Button className={classes.yellowBtn} 
                            onClick={() => AttachmentsAppend({ title: "Altered Calling Criteria" })}>
                                Attach Photo
                            </Button> */}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}

export default withWidth()(React.memo(withRouter(SubFormWidget)));